<template>
  <div class="app-itemised-bills">
    <slot name="txtBefore"><h2>Verbindungsübersicht</h2></slot>
    <div class="itemised-bills" v-if="currentEvnConfiguration.evn == 'ALL' || currentEvnConfiguration.evn == 'ANO'">
      <div class="itemised-bills-header">
        <slot name="txtAvailable"><p>Hier finden Sie alle einzelnen Verbindungen des laufenden Monats, die Sie bis gestern getätigt haben. Bitte wählen Sie einen Zeitraum in den letzten 80 Tagen aus, für den Sie Ihre Verbindungen einsehen möchten. Beachten Sie, dass Servicegebühren nicht in der Verbindungsübersicht enthalten sind.</p></slot>
        <p class="msisdn" v-if="currentCustomer.contract.msisdn">
          <dyn-slot :slot-data="currentCustomer.contract.msisdn"><slot
            name="itemisedBillsOverviewPhoneNumber">Alle Verbindungen für die Rufnummer {{currentCustomer.contract.msisdn}}</slot></dyn-slot></p>
        <b-form class="itemised-bills-form"
                :id="'form' + _uid">
          <b-form-group class="date-group">
            <b-row>
              <b-col md="" sm="12">
                <b-form-group :label-for="'fromData' + _uid"
                  label-cols="auto"
                  label="von">
                  <DatePicker
                    :id="'fromData' + _uid"
                    @input="$v.filterStartDate.$touch"
                    :valid="isValid('filterStartDate')"
                    :date.sync="filterStartDate"
                    name="startDate"
                    :disabled="loading"
                    :calendar-options="{min: minDate }"
                  ></DatePicker>
                </b-form-group>
              </b-col>
              <b-col md="" sm="12">
                <b-form-group :label-for="'toData' + _uid"
                  label-cols="auto"
                  label="bis">
                  <DatePicker
                    :id="'toData' + _uid"
                    @input="$v.filterEndDate.$touch"
                    :valid="isValid('filterEndDate')"
                    :date.sync="filterEndDate"
                    name="endDate"
                    :disabled="loading"
                  ></DatePicker>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form-group>
          <Stepper
            :show-prev="false"
            @next="refreshQuery()"
            :loading-next="loading"
          >
            <template #btnNext>
              <slot name="btnNext"></slot>
            </template>
          </Stepper>
        </b-form>
      </div>

      <div v-if="splittedItemisedBills.all.length > 0 && !loading">
        <!-- national -->
        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.natfestnetz" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Verbindungen ins nationale Festnetz</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.mobilnetz" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Verbindungen in Mobilfunknetze</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.freiminuten" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Freiminuten</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.freisms" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Frei-SMS</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.sms" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">SMS</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.mms" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">MMS</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.sondernummern" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Sondernummern</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.daten" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Daten</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
          <template #col3Header>{{ ' ' }}</template>
          <template #col3Content>{{ ' ' }}</template>
          <template #col4Header>Volumen (byte)</template>
          <template #col4Content>{{ renderInDynSlot('slotData.details')}}</template>
        </itemised-billing-list>

        <itemised-billing-list v-if="extraData.naming" :itemised-bill-group="splittedItemisedBills.dienste" tag="div" class="row" :mapping="extraData.naming.dienste">
          <template #headline>
            <div class="col headline_col1">Dienste</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
          <template #col3Header>Bemerkung</template>
          <template #col3Content>{{ renderInDynSlot('mapping[slotData.groupKey] || " "') }}</template>
          <template #col4Header>{{ ' ' }}</template>
          <template #col4Content>{{ ' ' }}</template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.ausland" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Internationale Verbindungen</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.websession" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Websession</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.knownoptions" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Rossmann Option</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.unknownoptions" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Fremde Tarifoptionen</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
        </itemised-billing-list>

        <itemised-billing-list :itemised-bill-group="splittedItemisedBills.topup" tag="div" class="row">
          <template #headline>
            <div class="col headline_col1">Aufladungen</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
          <template #col3Header>{{ ' ' }}</template>
          <template #col3Content>{{ ' ' }}</template>
          <template #col4Header>{{ ' ' }}</template>
          <template #col4Content>{{ ' ' }}</template>
          <template #col5Header>Betrag</template>
        </itemised-billing-list>
        <itemised-billing-list v-if="extraData.naming" :itemised-bill-group="splittedItemisedBills.cdt" tag="div" class="row" :mapping="extraData.naming.cdt">
          <template #headline>
            <div class="col headline_col1">Gutschriften</div><div class="col headline_col2">{{ renderInDynSlot('currencyFormatter(sum / 10000)') }}</div>
          </template>
          <template #col3Header>Bemerkung</template>
          <template #col3Content>{{ renderInDynSlot('mapping[slotData.groupKey] || " "') }}</template>
          <template #col4Header>{{ ' ' }}</template>
          <template #col4Content>{{ ' ' }}</template>
          <template #col5Header>Betrag</template>
        </itemised-billing-list>
      </div>
      <div class="notFound" v-else-if="!loading">
        Für den angegebenen Zeitraum wurden keine Verbindungen gefunden
      </div>
    </div>

    <div class="itemised-bills notAvailable" v-else-if="currentEvnConfiguration.evn === 'NOT'">
      <slot name="txtNotAvailable">
      <strong>Ihr Einzelverbindungsnachweis ist derzeit deaktiviert.</strong><br>
        Wenn Sie hier Ihre Verbindungen angezeigt bekommen möchten, müssen Sie zunächst im Bereich "Persönliche Daten ändern" die Anzeige des Einzelverbindungsnachweises aktivieren.</slot>
    </div>
    <div class="itemised-bills" v-else>
      <b-overlay class="btn-next-overlay" :show="true" spinner-small></b-overlay>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import isValid from '../../../../../mixins/isValid'
import { validationMixin } from 'vuelidate'
import { isSameOrAfter, validDate, validDateFormat, validDatePeriod } from '@/validators/date'
import { required } from 'vuelidate/lib/validators'
import DatePicker from '../../../../generic/DatePicker.vue'
import Stepper from '../../../../generic/Stepper.vue'
import ItemisedBillingList from '../ItemisedBillingList.vue'
import transaction from '@/mixins/transaction'
import preFilledInput from '@/mixins/preFilledInput'

const _Today = new Date()
const _FirstOfMonth = new Date()
_FirstOfMonth.setDate(1)

export default {
  name: 'ItemisedBillingOverview',
  components: { DatePicker, Stepper, ItemisedBillingList },
  computed: {
    extraData () {
      return this.decodedExtra
    },
    minDate () {
      const mindate = new Date()
      mindate.setDate(mindate.getDate() - 80)
      return mindate
    },
    today () {
      return this.$config.calendar.formatter.dateFormatter.format(_Today)
    },
    firstOfMonth () {
      return this.$config.calendar.formatter.dateFormatter.format(_FirstOfMonth)
    }
  },
  props: {
    extra: {
      type: String
    }
  },
  data () {
    return {
      splittedItemisedBills: {
        all: [],
        natfestnetz: [],
        mobilnetz: [],
        freiminuten: [],
        freisms: [],
        sms: [],
        mms: [],
        sondernummern: [],
        daten: [],
        dienste: [],
        ausland: [],
        cdt: [],
        topup: [],
        websession: [],
        knownoptions: [],
        unknownoptions: []
      },
      currentCustomer: {
        contract: {
          msisdn: ''
        },
        itemisedBills: {
        }
      },
      currentEvnConfiguration: {
        evn: ''
      },
      loading: false
    }
  },
  mixins: [
    preFilledInput('filterStartDate', 'firstOfMonth'),
    preFilledInput('filterEndDate', 'today'),
    preFilledInput('displayStartDate', 'firstOfMonth'),
    preFilledInput('displayEndDate', 'today'),
    validationMixin,
    isValid,
    transaction('itemisedBills')
  ],
  validations () {
    return {
      filterStartDate: {
        validDate,
        validDatePeriod: validDatePeriod(80),
        validDateFormat,
        required
      },
      filterEndDate: {
        validDate,
        validDatePeriod: validDatePeriod(80),
        validDateFormat,
        afterStartDate: (endDate, vm) => {
          const startDate = vm.filterStartDate
          return isSameOrAfter(startDate, endDate)
        },
        required
      }
    }
  },
  methods: {
    refreshQuery () {
      this.displayStartDate = this.filterStartDate
      this.displayEndDate = this.filterEndDate
      this.loading = true
      this.$apollo.queries.currentCustomer.refetch({
        filter: this.getFilter()
      }).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getFilter () {
      return {
        from: this.filterStartDate,
        to: this.filterEndDate
      }
    },
    renderInDynSlot (exp) {
      return '{{ ' + exp + '}}'
    },
    $_resetSplittedItemisedBills () {
      this.splittedItemisedBills.all = []
      this.splittedItemisedBills.natfestnetz = []
      this.splittedItemisedBills.mobilnetz = []
      this.splittedItemisedBills.freiminuten = []
      this.splittedItemisedBills.freisms = []
      this.splittedItemisedBills.sms = []
      this.splittedItemisedBills.mms = []
      this.splittedItemisedBills.sondernummern = []
      this.splittedItemisedBills.daten = []
      this.splittedItemisedBills.dienste = []
      this.splittedItemisedBills.ausland = []
      this.splittedItemisedBills.cdt = []
      this.splittedItemisedBills.topup = []
      this.splittedItemisedBills.websession = []
      this.splittedItemisedBills.knownoptions = []
      this.splittedItemisedBills.unknownoptions = []
    },
    $_filterCDR (bill) {
      if ((bill.productCode === 'FIXEDNET' || bill.productCode === 'BESTFRIEND' || bill.productCode === 'BESTCITY') && bill.toCountry === 'DE' && bill.value !== 0) {
        this.splittedItemisedBills.natfestnetz.push(bill)
      } else if ((bill.productCode === 'MOBILE' || bill.productCode === 'COMMUNITY') && (bill.toCountry === 'DE') && bill.value !== 0) {
        this.splittedItemisedBills.mobilnetz.push(bill)
      } else if (bill.value === 0) {
        this.splittedItemisedBills.freiminuten.push(bill)
      } else if (bill.productCode === 'SERVICENUMBER') {
        this.splittedItemisedBills.sondernummern.push(bill)
      } else if (bill.productCode === 'MAILBOX' && bill.value !== 0) {
        this.splittedItemisedBills.dienste.push(bill)
      } else if (bill.toCountry !== 'DE' || bill.fromCountry !== 'DE') {
        this.splittedItemisedBills.ausland.push(bill)
      }
    },
    $_filterSMS (bill) {
      if (bill.productCode !== 'SERVICENUMBER' && bill.productCode !== 'MAILBOX' && bill.value === 0) {
        this.splittedItemisedBills.freisms.push(bill)
      } else if (bill.toCountry === 'DE' && bill.fromCountry === 'DE' && bill.value !== 0) {
        this.splittedItemisedBills.sms.push(bill)
      } else if (bill.toCountry !== 'DE' || bill.fromCountry !== 'DE') {
        this.splittedItemisedBills.ausland.push(bill)
      }
    },
    $_filterMMS (bill) {
      if (bill.value !== 0) {
        this.splittedItemisedBills.mms.push(bill)
      }
    },
    $_filterGPR (bill) {
      if (bill.value !== 0) {
        this.splittedItemisedBills.daten.push(bill)
      }
    },
    $_filterCDT (bill) {
      if (bill.groupKey === 'TOPUP' || bill.groupKey === 'VFTOPUP') {
        // Aufladungen
        this.splittedItemisedBills.topup.push(bill)
      } else {
        this.splittedItemisedBills.cdt.push(bill)
      }
    },
    $_filterSRV (bill) {
      if (bill.groupKey === 'ABO' && bill.value !== 0) {
        if (this.extraData?.tarifOptions?.additionalData[bill.details.trim()]) {
          this.splittedItemisedBills.knownoptions.push(bill)
        } else {
          this.splittedItemisedBills.unknownoptions.push(bill)
        }
      } else if (bill.value !== 0) { // Service Record (kostenpflichtige individuelle Services)
        if (bill.requestorID === 'Websession') {
          this.splittedItemisedBills.websession.push(bill)
        } else {
          this.splittedItemisedBills.dienste.push(bill)
        }
      }
    },
    $_filterSSR (bill) {
      if (bill.groupKey === 'ABO' && bill.value !== 0) {
        if (this.extraData?.tarifOptions?.additionalData[bill.details.trim()]) {
          this.splittedItemisedBills.knownoptions.push(bill)
        } else {
          this.splittedItemisedBills.unknownoptions.push(bill)
        }
      } else if (bill.productCode === 'FLAT' && bill.value !== 0) {
        this.splittedItemisedBills.dienste.push(bill)
      }
    },
    $_filterItemisedBills () {
      const bills = this.currentCustomer?.itemisedBills
      this.$_resetSplittedItemisedBills()

      if (bills) {
        bills.forEach((bill, index) => {
          this.splittedItemisedBills.all.push(bill)

          switch (bill.typeKey) {
            case 'CDR':
              this.$_filterCDR(bill)
              break
            case 'SMS':
              this.$_filterSMS(bill)
              break
            case 'MMS':
              this.$_filterMMS(bill)
              break
            case 'GPR':
            case 'GPRS':
              this.$_filterGPR(bill)
              break
            case 'CDT':
              this.$_filterCDT(bill)
              break
            case 'SRV':
              this.$_filterSRV(bill)
              break
            case 'SSR':
              this.$_filterSSR(bill)
              break
            case 'INF':
              break
          }
        })
      }
    }
  },
  created () {
    try {
      this.decodedExtra = JSON.parse(atob(this.extra))
    } catch (e) {
      this.decodedExtra = {}
    }
  },
  apollo: {
    currentCustomer: function () {
      const me = this
      me.loading = true
      return wrapQuery(
        gql`query itemisedBills ($filter: ItemisedBillFilterInput){
        currentCustomer {
          contract {
            msisdn
          }
          itemisedBills(filter: $filter) {
            actionDate
            destination
            details
            duration
            fromCountry
            groupKey
            id
            productCode
            requestorID
            toCountry
            typeKey
            value
          }
        }
      }`, this, 'currentCustomer', {
          filter: this.getFilter()
        }, () => {
          this.$_filterItemisedBills()

          me.loading = false
        }, {},
        () => {
          me.loading = false
        }
      )
    },
    currentEvnConfiguration: function () {
      return wrapQuery(
        gql`query itemisedBills {
          currentEvnConfiguration {
              evn
          }
        }`, this, 'currentEvnConfiguration'
      )
    }
  }
}
</script>
